import { useEffect, useRef, useState } from "react";
import { AUTH_ENABLED, type AuthUser } from "../lib/auth";

interface Props {
  user: AuthUser;
  onSignOut: () => void;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function UserMenu({ user, onSignOut }: Props) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div className="user-menu" ref={ref}>
      <button
        type="button"
        className="avatar"
        title={user.name}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {initials(user.name)}
      </button>
      {open && (
        <div className="user-menu-pop" role="menu">
          <div className="user-menu-head">
            <div className="user-menu-name">{user.name}</div>
            <div className="user-menu-email">{user.email}</div>
            <div className="user-menu-role">{user.role}</div>
          </div>
          {AUTH_ENABLED && (
            <>
              <div className="user-menu-sep" />
              <button
                type="button"
                className="user-menu-item"
                onClick={() => {
                  setOpen(false);
                  onSignOut();
                }}
              >
                <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden>
                  <path
                    d="M6 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3M10 11l3-3-3-3M13 8H6"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Sign out
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
